import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative h-[90vh] min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <img
        src="https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/16c538eb-bff5-42db-8389-59a24ac94f9c_WhatsApp-Image-2026-03-31-at-12.18.56.jpeg?v=2e0c3211eced2e699fd4eec90c3fa381"
        alt="Oficina moderna Vidal Ferrer Asesores"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60" />

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 max-w-4xl mx-auto flex flex-col items-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-5 py-2 mb-6 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 bg-[#A0D080] rounded-full" />
          <span className="text-white/90 text-xs tracking-widest uppercase">Asesoría Integral · Más de 25 años de experiencia</span>
        </div>

        {/* Title */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Soluciones Fiscales y
          <span className="block text-[#A0D080]">Laborales a tu Medida</span>
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-white/85 max-w-2xl leading-relaxed mb-10">
          Expertos certificados en optimización fiscal, gestión laboral y seguros corporativos. Protegemos tu empresa con asesoramiento personalizado y soluciones efectivas.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <Link
            to="/contacto"
            className="flex items-center gap-2 bg-[#6B7F5C] hover:bg-[#5A6E4B] text-white font-semibold px-8 py-4 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-calendar-check-line" />
            </div>
            Agendar Cita Gratuita
          </Link>
          <Link
            to="/servicios"
            className="flex items-center gap-2 border-2 border-white/70 text-white hover:bg-white hover:text-[#1A1A1A] font-semibold px-8 py-4 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Ver Servicios
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </Link>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <div className="w-5 h-5 flex items-center justify-center text-white/50">
            <i className="ri-arrow-down-line text-lg" />
          </div>
        </div>
      </div>
    </section>
  );
}
